<header
  class="sticky top-0 z-50 border-b border-[#e9e9e9] bg-white print:hidden"
>
  <div class="container mx-auto px-3">
    <div class="flex h-20 items-center justify-between">
      <a
        [href]="locationUrl()"
        class="relative top-[-4px] flex h-14 shrink-0 items-center md:h-20"
        aria-label="Chef Ami home"
      >
        <img
          [ngSrc]="logoImageUrl()"
          alt="Chef Ami logo"
          width="176"
          height="80"
          priority
          class="h-full w-auto"
        />
        <span
          class="text-[10px] md:text-xs uppercase absolute -bottom-[4px] md:bottom-[6px] right-0"
          >{{ locationName() }}</span
        >
      </a>

      <nav
        aria-label="Main navigation"
        class="hidden lg:flex flex-1 justify-center"
      >
        <ul
          class="flex items-center space-x-1 lg:space-x-2 h-20 desktop-menubar"
        >
          @for (item of primaryMenus(); track item.id) {
            @if (item.submenu) {
              <li
                class="relative menu-parent h-full"
                (mouseenter)="openDesktopMenu(item.id)"
                (mouseleave)="closeDesktopMenus()"
                (focusout)="onDesktopMenuFocusOut($event)"
              >
                <button
                  type="button"
                  [attr.aria-controls]="'submenu-' + item.id"
                  [attr.aria-expanded]="isDesktopMenuExpanded(item.id)"
                  class="menu-item-with-submenu h-full px-3 py-2 transition-all bg-transparent"
                  [class.open]="isDesktopMenuExpanded(item.id)"
                  (click)="toggleDesktopMenu(item.id)"
                >
                  {{ item.label }}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 42 42"
                    fill="currentColor"
                    class="submenu-arrow"
                    aria-hidden="true"
                  >
                    <polygon
                      points="11,38.32 28.609,21 11,3.68 13.72,1 34,21.01 13.72,41"
                      transform="rotate(90 21 21)"
                    />
                  </svg>
                </button>
                <ul
                  [id]="'submenu-' + item.id"
                  class="submenu absolute left-0 w-56 bg-white shadow-xl py-2 z-50"
                  [class.open]="isDesktopMenuExpanded(item.id)"
                >
                  @for (subItem of item.submenu; track subItem.path) {
                    <li>
                      <a
                        [routerLink]="subItem.path"
                        routerLinkActive
                        ariaCurrentWhenActive="page"
                        class="block px-5 py-2.5 hover:bg-gray-50 transition-colors"
                        (click)="onMenuNavigation()"
                      >
                        {{ subItem.label }}
                      </a>
                    </li>
                  }
                </ul>
              </li>
            } @else {
              <li class="h-full">
                <a
                  [routerLink]="item.path"
                  routerLinkActive="active"
                  ariaCurrentWhenActive="page"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="menu-link h-full flex items-center px-3 py-2 transition-all"
                  (click)="onMenuNavigation()"
                >
                  {{ item.label }}
                </a>
              </li>
            }
          }
        </ul>
      </nav>

      <nav aria-label="Account navigation" class="hidden lg:block">
        <ul class="h-20 desktop-menubar">
          <li
            class="relative menu-parent h-full"
            (mouseenter)="openDesktopMenu(accountMenu().id)"
            (mouseleave)="closeDesktopMenus()"
            (focusout)="onDesktopMenuFocusOut($event)"
          >
            <button
              type="button"
              [attr.aria-controls]="'submenu-' + accountMenu().id"
              [attr.aria-expanded]="isDesktopMenuExpanded(accountMenu().id)"
              class="menu-item-with-submenu inline-flex h-full items-center gap-2 bg-transparent px-3 py-2 transition-all"
              [class.open]="isDesktopMenuExpanded(accountMenu().id)"
              (click)="toggleDesktopMenu(accountMenu().id)"
            >
              <span>{{ accountMenu().label }}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 42 42"
                fill="currentColor"
                class="submenu-arrow"
                aria-hidden="true"
              >
                <polygon
                  points="11,38.32 28.609,21 11,3.68 13.72,1 34,21.01 13.72,41"
                  transform="rotate(90 21 21)"
                />
              </svg>
            </button>

            <ul
              [id]="'submenu-' + accountMenu().id"
              class="submenu absolute right-0 top-full z-50 w-52 bg-white py-2 shadow-xl"
              [class.open]="isDesktopMenuExpanded(accountMenu().id)"
            >
              @for (
                subItem of accountMenu().submenu || [];
                track subItem.path
              ) {
                <li>
                  @if (subItem.path) {
                    <a
                      [routerLink]="subItem.path"
                      routerLinkActive
                      ariaCurrentWhenActive="page"
                      class="block px-5 py-2.5 transition-colors hover:bg-gray-50"
                      (click)="onMenuNavigation()"
                    >
                      {{ subItem.label }}
                    </a>
                  }
                  @if (subItem.action) {
                    <button
                      type="button"
                      class="block w-full px-5 py-2.5 text-left transition-colors hover:bg-gray-50"
                      (click)="closeDesktopMenus(); subItem.action()"
                    >
                      {{ subItem.label }}
                    </button>
                  }
                </li>
              }
            </ul>
          </li>
        </ul>
      </nav>

      <button
        type="button"
        class="inline-flex items-center justify-center px-3 py-2 text-graphite lg:hidden"
        aria-label="Open navigation menu"
        aria-controls="mobile-menu"
        [attr.aria-expanded]="isMobileMenuOpen()"
        (click)="toggleMobileMenu()"
      >
        <svg
          class="h-6 w-6"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          aria-hidden="true"
        >
          <path d="M3 6h18M3 12h18M3 18h18" stroke-linecap="round"></path>
        </svg>
      </button>
    </div>
  </div>

  <dialog
    #mobileMenuDialog
    class="mobile-dialog fixed inset-0 z-[60] p-0 lg:hidden"
    id="mobile-menu"
    aria-label="Mobile navigation menu"
    tabindex="-1"
    [class.open]="isMobileMenuOpen()"
    (click)="onMobileDialogClick($event)"
    (keydown)="onMobileDialogKeydown($event)"
    (cancel)="onMobileDialogCancel($event)"
    (close)="onMobileDialogClose()"
  >
    <nav
      class="mobile-nav-panel absolute left-0 top-0 h-full w-80 max-w-[88vw] overflow-y-auto bg-white shadow-[0_12px_30px_rgba(0,0,0,0.22)]"
      aria-label="Mobile navigation panel"
    >
      <div class="flex justify-end p-4">
        <button
          type="button"
          class="inline-flex h-10 w-10 items-center justify-center rounded text-graphite"
          aria-label="Close navigation menu"
          (click)="closeMobileMenu()"
        >
          <svg
            class="h-6 w-6"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            aria-hidden="true"
          >
            <path d="M6 6l12 12M18 6l-12 12" stroke-linecap="round"></path>
          </svg>
        </button>
      </div>

      <div class="px-4 pb-6">
        @for (item of primaryMenus(); track item.id) {
          <a
            [routerLink]="item.path"
            routerLinkActive
            ariaCurrentWhenActive="page"
            class="block border-b border-gray-200 px-4 py-3 text-lg"
            (click)="onMenuNavigation()"
          >
            {{ item.label }}
          </a>
        }

        @for (
          subItem of accountMenu().submenu || [];
          track subItem.path;
          let isLast = $last
        ) {
          @if (subItem.action) {
            <button
              type="button"
              class="block w-full px-4 py-3 text-left text-lg"
              (click)="subItem.action()"
            >
              {{ subItem.label }}
            </button>
          } @else {
            <a
              [routerLink]="subItem.path"
              routerLinkActive
              ariaCurrentWhenActive="page"
              class="block px-4 py-3 text-lg"
              [class.border-b]="!isLast"
              [class.border-gray-200]="!isLast"
              (click)="onMenuNavigation()"
            >
              {{ subItem.label }}
            </a>
          }
        }
      </div>
    </nav>
  </dialog>
</header>
